<template>
  <div class="enterprise-member">
    <div class="opreationBox" style="margin-bottom: 10px;">
      <el-button type="primary" @click="downloadPartner('合伙人月度业绩表')">合伙人月度业绩表</el-button>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="data"
        border
        style="width: 100%"
      >
        <el-table-column align="center" prop="name" label="二级合伙人姓名" />
        <el-table-column align="center" prop="nickName" label="微信昵称" />
        <el-table-column align="center" prop="phoneNumber" label="手机号" />
        <el-table-column align="center" prop="createTime" label="加盟时间" />
        <el-table-column align="center" prop="panelCount" label="会员数量" />
        <el-table-column align="center" prop="panelFocusCount" label="会员关注数" />
        <el-table-column align="center" fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button plain size="mini" @click="look(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="params.pageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <downloadDialog ref="downloadDialog" />
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import {SetTableH} from "../../../utils/utils"
  import { getEnterpriseMember as getList, managerenterprisememberexport as downloadPartner } from 'api/request'
  import downloadDialog from "@/components/downloadDialog"
  export default {
    components: {
      downloadDialog
    },
    data() {
      return {
        params: {
          enterpriseId: sessionStorage.getItem('enterpriseId'),
          pageIndex: 1,
          pageSize: 20
        },
        total: 0,
        data: [],
        loading: true,
        tableH: '250',
        moment: moment,
        userName: window.sessionStorage.getItem('loginuser') ? JSON.parse(window.sessionStorage.getItem('loginuser')).name : ''
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
    methods: {
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
      },
      look(row) {
        const { id } = row
        this.$router.push({ path: '/acc/enterpriseMemberDetail', query: { id }})
      },
      sizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      downloadPartner(title) {
        let downloadParams = { enterpriseId:  sessionStorage.getItem('enterpriseId') }
        const apiQueryStr = Object.keys(downloadParams).map(v => `&${v}=${downloadParams[v]}`).join('')
        this.$refs.downloadDialog.show({ api: downloadPartner, apiQueryStr: apiQueryStr, title })
      },
    }
  }
</script>

<style scoped lang="scss">
  .enterprise-member{
  
  }
</style>
